@if (uploadFileModalConfig) {
  <ent-modal-popup class="upload-file" [modalConfig]="uploadFileModalConfig" (closeModalPopup)="closeUploadFileModal()">
    <div modal-header>
      <h3 class="lfg-color">File upload</h3>
    </div>
    <div modal-body>
      <ent-accordion [autoScroll]="false">
        <ent-panel title="File types" [opened]="true" name="accordion1">
          <ul>
            <li>Lincoln accepts the following file types: PDF, GIF, JPG, JPEG, BMP, TIFF, TIF, DOC, DOCX, XLS and XLSX</li>
            <li>Files should not exceed 30MB</li>
            <li>File names should not include special characters, but may include spaces, underscores (_), hyphens (-) and a period (.)</li>
            <li>Secured or password-protected files will not transmit correctly.</li>
          </ul>
        </ent-panel>
      </ent-accordion>
      <div aria-live="assertive">
        @if (displayErrMsg()) {
          <div>
            @if (isUploadSuccess()) {
              <ent-alert-message type="success" class="fade-out">{{ message.fileUploadSuccess }}</ent-alert-message>
            }
            @if (isUploadFailure()) {
              <ent-alert-message type="error">{{ message.fileUploadFailure }}</ent-alert-message>
            }
            @if (isFileSizeError()) {
              <ent-alert-message type="error">{{ message.fileSizeError }}</ent-alert-message>
            }
            @if (isFileTypeError()) {
              <ent-alert-message type="error">We're sorry, Your file "{{ fileUploaded }}" {{ message.fileTypeError }}</ent-alert-message>
            }
            @if (isFileNameError()) {
              <ent-alert-message type="error">We're sorry, Your file "{{ fileUploaded }}" {{ message.fileNameError }}</ent-alert-message>
            }
            @if (isFileSameError()) {
              <ent-alert-message type="error">"{{ fileUploaded }}" You have already added this file or a file with the same name.</ent-alert-message>
            }
            @if (isVirusFile()) {
              <ent-alert-message type="error">"{{ fileUploaded }}" contains virus or Malware. Please upload healthy files.</ent-alert-message>
            }
            @if (isFileSizeZero()) {
              <ent-alert-message type="error">"{{ fileUploaded }}" has size zero. Please upload file with size greater than zero.</ent-alert-message>
            }
            @if (isPassProtectedFile()) {
              <ent-alert-message type="error">We're sorry, your file "{{ fileUploaded }}" {{ message.filePassProtectedError }}</ent-alert-message>
            }
          </div>
        }
      </div>
      <div aria-live="assertive">
        @if (removedFileADA()) {
          <span class="screen-reader-only">file removed successfully.</span>
        }
        @if (removedAllFilesADA()) {
          <span class="screen-reader-only">all files removed successfully.</span>
        }
        @if (fileSelectedADA()) {
          <span class="screen-reader-only">file {{fileUploaded}} selected successfully.</span>
        }
      </div>
      @if (progressValue !== 0) {
        <div class="widget-cont">
          <div class="widget-header">
            <h3 class="no-margin padding20 lfg-color font-weight200">File upload progress</h3>
          </div>
          <div class="widget-header">
            <div class="widget-content padding20">
              <progress id="progress" class="progress" max="100" [value]="progressValue">70%</progress>
            </div>
          </div>
        </div>
      }
      <div class="add-file">
        <div>
          <input [ngStyle]="{'visibility': 'hidden'}" class="screen-reader-only" #uploadFilesInp type="file" id="uploadfile" title="uploadfile" name="uploadfile" (change)="onFileSelected($event)" />
          <a href="javascript:void(0)" for="uploadfile" tabindex="0" (click)="triggerClick(uploadFilesInp)" (keydown)="triggerClick(uploadFilesInp, $event)" id="uploadfileAnch" [ngClass]="{'btn--link-disabled': isUploading()}">
            <i class="fas fa-circle fa-circle-custom" aria-hidden="true">
              <i class="fas fa-plus fa-plus-custom" aria-hidden="true"></i></i> ADD FILE</a>
            </div>
            <div>
              <em class="divider" aria-hidden="true">&#124;</em>
              @if (allFileDetails.length > 0 && !isUploading()) {
                <button type="button" class="remove-all active" entLinkButton (click)="removeAllFiles();">
                  <img src = "{{ environment.uiBaseUrl }}assets/images/delete_all.svg" alt="Remove all files" aria-hidden="true"/>
                  <em>Remove all</em>
                </button>
              }
              @if (allFileDetails.length === 0 || isUploading()) {
                <div entLinkButton class="btn--link-disabled remove-all" aria-label="Remove all files button unavailable">
                  <img src="{{ environment.uiBaseUrl }}assets/images/delete_all-diseble.svg" alt="Remove all files unavailable" aria-hidden="true" />
                  <em aria-hidden="true">Remove all</em>
                </div>
              }
            </div>
          </div>
          <div class="file-selected-header">
            <h6 class="file-name">File name</h6>
          </div>
          @if (allFileDetails.length === 0) {
            <div class="file-selected-header">
              <div class="file-name-cont file-name" >No Files have been uploaded yet</div>
              <div entLinkButton class="btn--link-disabled action" aria-label="remove file button unavailable">
                <i class="far fa-trash-alt" aria-hidden="true"></i>
                <span aria-hidden="true">Remove</span>
              </div>
            </div>
          }
          @if (allFileDetails.length > 0) {
            <ng-container aria-live="assertive">
              @for (file of allFileDetails; track file; let i = $index) {
                <div class="file-selected-header">
                  <div class="file-name-cont file-name">{{ file.fileName }}</div>
                  <button type="button" class="file-name-cont action" (click)="removeFile(i)" entLinkButton [ngClass]="{'btn--link-disabled': isUploadSuccess() || isUploading()}">
                    <i class="far fa-trash-alt" aria-hidden="true"></i> Remove</button>
                  </div>
                }
              </ng-container>
            }
            <p>Closing the window while transmission is in progress will send partial files. Wait for a confirmation message before closing the screen. The message confirms that you have securely submitted your files to Lincoln Financial.</p>
          </div>
          <div modal-footer>
            <ent-left-button-tray>
              <button type="" class='btn btn--custom' entDefaultButton (click)="uploadFiles();" [disabled]="isUploading() || allFileDetails.length === 0 || isFileSizeError() || (isFileSizeError() && allFileDetails.length === 0)">Upload</button>
              <button type="button" class="btn" entLinkButton (keydown)="onTab($event)" (click)="closeUploadFileModal()" [ngClass]="{'btn--link-disabled': isUploading()}">Cancel</button>
            </ent-left-button-tray>
          </div>
        </ent-modal-popup>
      }
